import React from "react";
import { FaSearch } from "react-icons/fa";
import { formatSquadInfo } from "../../../components/UI/DesignStandards";

const controlClass =
  "h-10 w-full px-3 text-sm border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink";

const SearchAndFilters = ({
  searchQuery,
  onSearchChange,
  tournamentFilter,
  onTournamentFilterChange,
  eventFilter,
  onEventFilterChange,
  squadFilter,
  onSquadFilterChange,
  availableTournaments = [],
  availableEvents = [],
  availableSquads = [],
  showTournamentNameOnSquads = false,
  onClearFilters,
}) => {
  const hasFilters = Boolean(
    searchQuery || tournamentFilter || eventFilter || squadFilter
  );
  const showTournament = availableTournaments.length > 1;
  const showEvent = availableEvents.length > 1;
  const showSquad = availableSquads.length > 1;

  return (
    <div className="px-4 sm:px-6 py-4 border-t border-brand-charcoal/10">
      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:items-center">
        <div className="relative flex-1 min-w-[14rem]">
          <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted w-3.5 h-3.5" />
          <input
            type="search"
            value={searchQuery}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search bowler, tournament, or event"
            aria-label="Search signups"
            className={`${controlClass} pl-9`}
          />
        </div>
        {showTournament ? (
          <div className="sm:min-w-[11rem] sm:max-w-[16rem] flex-1">
            <select
              aria-label="Tournament"
              value={tournamentFilter || ""}
              onChange={(event) =>
                onTournamentFilterChange(event.target.value || "")
              }
              className={controlClass}
            >
              <option value="">All tournaments</option>
              {availableTournaments.map((tournament) => (
                <option key={tournament.id} value={tournament.id}>
                  {tournament.name}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {showEvent ? (
          <div className="sm:min-w-[10rem] sm:max-w-[14rem] flex-1">
            <select
              aria-label="Event"
              value={eventFilter || ""}
              onChange={(event) =>
                onEventFilterChange(event.target.value || "")
              }
              className={controlClass}
            >
              <option value="">All events</option>
              {availableEvents.map((eventName) => (
                <option key={eventName} value={eventName}>
                  {eventName}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {showSquad ? (
          <div className="sm:min-w-[12rem] sm:max-w-[18rem] flex-1">
            <select
              aria-label="Squad"
              value={squadFilter || ""}
              onChange={(event) =>
                onSquadFilterChange(event.target.value || "")
              }
              className={controlClass}
            >
              <option value="">All squads</option>
              {availableSquads.map((squad) => (
                <option key={squad.id} value={squad.id}>
                  {showTournamentNameOnSquads && squad.tournamentName
                    ? `${squad.tournamentName} · `
                    : ""}
                  {formatSquadInfo(squad.squadDate, squad.squadTime)}
                  {squad.centerName ? ` · ${squad.centerName}` : ""}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {hasFilters ? (
          <button
            type="button"
            onClick={onClearFilters}
            className="h-10 px-2 text-sm font-display font-bold text-brand-muted hover:text-brand-charcoal"
          >
            Clear
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SearchAndFilters;
